function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.753662,
  width: 342,
  height: 229,
  stroke: "black",
  strokeDasharray: "4 4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M183 105.254H161C160.448 105.254 160 105.701 160 106.254V124.254C160 124.806 160.448 125.254 161 125.254H183C183.552 125.254 184 124.806 184 124.254V106.254C184 105.701 183.552 105.254 183 105.254Z",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M160 120.254L166.293 113.961C166.386 113.868 166.496 113.794 166.617 113.744C166.739 113.694 166.869 113.668 167 113.668C167.131 113.668 167.261 113.694 167.383 113.744C167.504 113.794 167.614 113.868 167.707 113.961L173.293 119.547C173.386 119.639 173.496 119.713 173.617 119.763C173.739 119.814 173.869 119.839 174 119.839C174.131 119.839 174.261 119.814 174.383 119.763C174.504 119.713 174.614 119.639 174.707 119.547L177.293 116.961C177.386 116.868 177.496 116.794 177.617 116.744C177.739 116.694 177.869 116.668 178 116.668C178.131 116.668 178.261 116.694 178.383 116.744C178.504 116.794 178.614 116.868 178.707 116.961L184 122.254",
  stroke: "black",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M175.5 113.254C176.328 113.254 177 112.582 177 111.754C177 110.925 176.328 110.254 175.5 110.254C174.672 110.254 174 110.925 174 111.754C174 112.582 174.672 113.254 175.5 113.254Z",
  fill: "black"
});

function SvgEmptyCollec(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 231,
    viewBox: "0 0 343 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCollec);
export default __webpack_public_path__ + "static/media/EmptyCollec.c63fd95cf1df8df93a469b328162cdc6.svg";
export { ForwardRef as ReactComponent };